import React from 'react';
import classnames from 'classnames';
import i18n from 'i18next';

import { Card } from 'uikit/cards';
import { Typo } from 'uikit/content';
import getDateString from '../helpers/getDateString';

import styles from '../styles/profileCredentialsListItem.module.scss';

const ProfileCredentialsListItem = ({ credential, isCurrentUser, onCredentialClick }) => (
  // eslint-disable-next-line max-len
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
  <Card
    element="button"
    className={classnames(styles.element, {
      [styles.link]: isCurrentUser,
    })}
    onClick={isCurrentUser ? () => onCredentialClick(credential.user_credential_id) : undefined}
  >
    <div className={styles.content}>
      <div className={styles.image}>
        <img
          className={styles.imageSrc}
          src={credential.badge_absolute_url}
          alt={credential.name}
        />
      </div>
      <div className={styles.inner}>
        <Typo element="span" variant="s03" weight="medium">
          {credential.name}
        </Typo>
        <Typo color="secondary" element="span" variant="s02">
          {`${i18n.t('earned')}: ${getDateString(credential.created_at)}`}
        </Typo>
      </div>
    </div>
  </Card>
);

export default React.memo(ProfileCredentialsListItem);
